import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook that checks if a specific key is present in the URL query parameters.
 * If present, it calls the provided callback function.
 * 
 * @param {string} key - The query parameter key to check for.
 * @param {Function} callback - The function to call if the key is present.
 */
const useQueryAction = (key, callback) => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(key)) {
      if (typeof callback === "function") {
        callback();
      }
    }
  }, [location.search, key, callback]);
};

export default useQueryAction;
